import { ITimeOffRequestState } from '@/store/timeoff-request';
import { ITimeOffRequestMutations } from './mutations.types';
import {
  IMentionAttachmentCommentData,
  ITimeOffRequestData,
  IUserData
} from '@/models';
import { ITransition } from '@/models/transition';

export const mutations: ITimeOffRequestMutations = {
  SET_COUNT(state: ITimeOffRequestState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: ITimeOffRequestState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: ITimeOffRequestState): void {
    state.count -= 1;
  },

  SET_TIME_OFF_REQUESTS(
    state: ITimeOffRequestState,
    payload: ITimeOffRequestData[]
  ): void {
    state.timeOffRequests = payload;
  },

  ADD_TIME_OFF_REQUEST(
    state: ITimeOffRequestState,
    payload: ITimeOffRequestData
  ): void {
    state.timeOffRequests.push(payload);
  },

  UPDATE_TIME_OFF_REQUEST(
    state: ITimeOffRequestState,
    payload: ITimeOffRequestData
  ): void {
    const index = state.timeOffRequests.findIndex(
      (timeOff: ITimeOffRequestData) => timeOff.id === payload.id
    );

    state.timeOffRequests.splice(index, 1, payload);
  },

  REMOVE_TIME_OFF_REQUEST(state: ITimeOffRequestState, payload: number): void {
    const index = state.timeOffRequests.findIndex(
      (timeOff: ITimeOffRequestData) => timeOff.id === payload
    );

    state.timeOffRequests.splice(index, 1);
  },

  SET_TIME_OFF_REQUEST_ACTIVITIES(
    state: ITimeOffRequestState,
    payload: ITransition[]
  ): void {
    state.activities = payload;
  },

  SET_UNAPPROVED_TIME_OFF_REQUESTS(
    state: ITimeOffRequestState,
    payload: ITimeOffRequestData[]
  ): void {
    state.unapprovedTimeOffRequests = payload;
  },

  // TIME-OFF COMMENTS
  SET_TIME_OFF_REQUEST_COMMENTS(
    state: ITimeOffRequestState,
    payload: IMentionAttachmentCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_TIME_OFF_REQUEST_COMMENT(
    state: ITimeOffRequestState,
    payload: IMentionAttachmentCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_TIME_OFF_REQUEST_COMMENT(
    state: ITimeOffRequestState,
    payload: IMentionAttachmentCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_TIME_OFF_REQUEST_COMMENT(
    state: ITimeOffRequestState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_LAST_CREATED_REQUEST_COMMENT_ID(
    state: ITimeOffRequestState,
    payload: number
  ): void {
    state.lastCreatedRequestCommentId = payload;
  },

  SET_MENTIONABLE_USERS(
    state: ITimeOffRequestState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_PROMISE(state: ITimeOffRequestState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
